import Vue from "vue";

Vue.directive("focus", {
  inserted: function(el) {
    // eslint-disable-next-line import/no-named-as-default-member
    Vue.nextTick(function() {
      el.focus();
    });
  },
});
